(function () {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  function init() {
    const drawer = document.querySelector("[data-rknd-drawer]");
    if (!drawer) return;

    const panel = drawer.querySelector("[data-rknd-panel]");
    const overlay = drawer.querySelector("[data-rknd-overlay]");
    const crumbs = drawer.querySelector("[data-rknd-crumbs]");
    const rootView = panel.querySelector('[data-rknd-view][data-level="1"]');
    let rkndCardSwiper = null;

    let stack = [];

      // Initialize swiper once DOM is ready (even if drawer hidden)
  initCardSwiper(panel);


    function show(view) {
      // hide all
      panel.querySelectorAll("[data-rknd-view]").forEach(v => v.hidden = true);
      // show target
      view.hidden = false;
    }

    function showRoot() {
      show(rootView);
      stack = [];
      if (crumbs) crumbs.textContent = "";
    }





    // function openDrawer() {
    //   drawer.setAttribute("aria-hidden", "false");
    //   requestAnimationFrame(() => {
    //     overlay.style.opacity = "1";
    //     panel.style.transform = "translateX(0)";
    //   });
    //   document.documentElement.classList.add("rknd-no-scroll");
    //   showRoot();
    // }

      function openDrawer(target = null) {
      drawer.setAttribute("aria-hidden", "false");
      requestAnimationFrame(() => {
        overlay.style.opacity = "1";
        panel.style.transform = "translateX(0)";
      });
      document.documentElement.classList.add("rknd-no-scroll");
      showRoot();

      if (!target) return;

      // make sure swiper is ready and updated
  initCardSwiper(panel);
  if (panel.querySelector('.rknd-cards__swiper')?.swiper) {
    panel.querySelector('.rknd-cards__swiper').swiper.update();
  }

    const norm = (s) => String(s || "").trim().toLowerCase();

    // 1) If an explicit subview id was passed, try that first
    if (target.id) {
      const opener = rootView.querySelector(`[data-rknd-open="${CSS.escape(target.id)}"]`);
      if (opener) {
        opener.dispatchEvent(new MouseEvent("click", { bubbles: true }));
        return;
      }
      const direct = panel.querySelector("#" + CSS.escape(target.id));
      if (direct) {
        show(direct);
        stack.push(target.id);
        if (crumbs) crumbs.textContent = "• " + (direct.getAttribute("aria-label") || "");
        return;
      }
    }

      // 2) If an index was passed (0-based among root parents)
      if (target.index != null) {
        const n = parseInt(target.index, 10);
        const openers = rootView.querySelectorAll(".rknd-row--parent [data-rknd-open]");
        if (openers[n]) {
          openers[n].dispatchEvent(new MouseEvent("click", { bubbles: true }));
          return;
        }
      }

      // 3) Preferred: match by LABEL (cross-section safe)
      if (target.label) {
        const wanted = norm(target.label);
        const parents = rootView.querySelectorAll(".rknd-row--parent");
        for (const li of parents) {
          const txt = norm(li.querySelector(".rknd-row__text")?.textContent);
          if (txt === wanted) {
            const opener = li.querySelector("[data-rknd-open]");
            if (opener) {
              opener.dispatchEvent(new MouseEvent("click", { bubbles: true }));
              return;
            }
          }
        }
      }
    }


    function closeDrawer() {
      overlay.style.opacity = "0";
      panel.style.transform = "translateX(-100%)";
      setTimeout(() => drawer.setAttribute("aria-hidden", "true"), 200);
      document.documentElement.classList.remove("rknd-no-scroll");
      document.documentElement.classList.remove("scroll-locked"); // 👈 add this line
      document.body.classList.remove("scroll-locked");            // 👈 and this one for safety

      showRoot();
    }

    function initCardSwiper(panel) {
  const container = panel.querySelector('.rknd-cards__swiper');
  const progressEl = panel.querySelector('.rknd-cards__progress');
  if (!container || !progressEl) return;

  // Avoid double init
  if (container.swiper) {
    container.swiper.update();
    return;
  }

  rkndCardSwiper = new Swiper(container, {
    slidesPerView: 1.3,        // 1.3 on all breakpoints
    spaceBetween: 10,          // 20px gap
    grabCursor: true,
    watchSlidesProgress: true,
    observer: true,            // observe hidden->visible
    observeParents: true,
    pagination: {
      el: progressEl,
      type: 'progressbar',
    },
  });
}

    // triggers
    // document.querySelectorAll("[data-rknd-open-trigger]").forEach(btn => {
    //   btn.addEventListener("click", e => { e.preventDefault(); e.stopImmediatePropagation(); openDrawer();  });
    // });

    // triggers (works from anywhere on the page)
    document.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-rknd-open-trigger]");
      if (!btn) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const target = {
        id: btn.dataset.rkndOpenSub || null,      // optional, if you ever want to pass a view id
        label: btn.dataset.rkndOpenLabel || null, // ← we use this now (Shop/Learn/Industries)
        index: btn.dataset.rkndOpenIndex || null  // optional, open Nth parent
      };

      openDrawer(target);
});




    overlay.addEventListener("click", closeDrawer);
    const closeBtn = drawer.querySelector("[data-rknd-close]");
    if (closeBtn) closeBtn.addEventListener("click", closeDrawer);
    document.addEventListener("keydown", e => { if (e.key === "Escape") closeDrawer(); });

    // handle open submenu
    panel.addEventListener("click", e => {
        
      const opener = e.target.closest("[data-rknd-open]");
      if (!opener) return;
      e.preventDefault();
      const id = opener.getAttribute("data-rknd-open");
      const target = id && panel.querySelector("#" + CSS.escape(id));
      if (!target) return;
      show(target);
      stack.push(id);
      if (crumbs) crumbs.textContent = "• " + (target.getAttribute("aria-label") || "");
    });

    // handle back
    panel.addEventListener("click", e => {
      const back = e.target.closest("[data-rknd-back]");
      if (!back) return;
      e.preventDefault();
      stack.pop();
      if (stack.length === 0) return showRoot();
      const id = stack[stack.length - 1];
      const target = panel.querySelector("#" + CSS.escape(id));
      if (target) {
        show(target);
        if (crumbs) crumbs.textContent = "• " + (target.getAttribute("aria-label") || "");
      } else {
        showRoot();
      }
    });
  }
})();